









































import { Component, Prop, Vue } from 'vue-property-decorator';
import {Computed} from 'vuex/types/helpers';
import AgeLabel from '@/components/ui/AgeLabel.vue';

@Component({
  components: {AgeLabel}
})
export default class AppHeader extends Vue {

  get langAndTokenSet() {
    return this.$store.getters.langAndTokenSet;
  }

  get userDataSet() {
    return this.$store.getters.userDataSet;
  }

  get ageInMonths() {
    if (this.$store.state.data && this.$store.state.data.base_info)
      return this.$store.state.data.base_info.current_age_months
    else return 0;
  }
  get ageInWeeks() {
    if (this.$store.state.data && this.$store.state.data.base_info)
      return this.$store.state.data.base_info.current_age_weeks
    else return 0;
  }

  get userData() {
    return this.$store.state.data;
  }

}
